// @flow
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import type { Personas } from '../types';
import { Container, Grid, Image, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchPersonas } from '../actions/personas';
import { loadMarketingPage } from '../actions/readMarketingPage';
import { getPersonasSortedAlphabetically } from '../reducers/personas';
import PageContent from '../components/PageContent';
import PageTitle from '../components/PageTitle';
import OtherProducts from '../components/OtherProducts';
import { fetchProducts } from '../actions';
import { findBySlug } from '../helpers';
import type { Product as ProductType } from '../types';

import { Link, Redirect } from 'react-router-dom';
import PageLoader from '../components/PageLoader';

type Props = {
  personas: Personas,
  match: {
    params: {
      community_slug: string
    }
  },
  fetchProducts: () => Promise<void>,
  fetchPersonas: () => Promise<void>,
  loadMarketingPage: (slug: string) => Promise<void>,
  products: Array<Object>,
  isFetchingMarketingPage: boolean,
  isFetchingPersonas: boolean,
  marketingPage: () => Promise<void>
};

class Community extends React.Component<Props> {
  componentDidMount() {
    this.props.fetchPersonas();
    this.props.loadMarketingPage('helix-personas-2018-homepage');
    this.props.fetchProducts();
    window.scrollTo(0, 0);
  }

  render() {
    const { products } = this.props;
    const slug = 'helix-personas';

    let currentProduct: ?ProductType;
    if (products) {
      // $FlowFixMe
      currentProduct = (findBySlug(products, slug): ProductType);
    }
    const personasUrl = this.props.match.params.community_slug;
    const personas = this.props.personas;
    const community = personas.find(
      persona => persona.postName === personasUrl.substring(0, 3)
    );

    if (
      this.props.isFetchingPersonas ||
      this.props.isFetchingMarketingPage ||
      !this.props.marketingPage ||
      !currentProduct
    ) {
      return <PageLoader />;
    }

    if (!community) {
      return <Redirect to="/" />;
    }

    const communityTiles = community
      ? community.personas
          .slice(0)
          .sort((a, b) => {
            // non-anonymous as you ordered...
            return b.acf.personacommunityNumber < a.acf.personacommunityNumber
              ? 1 // if b should come earlier, push a to end
              : b.acf.personacommunityNumber > a.acf.personacommunityNumber
              ? -1 // if b should come later, push a to begin
              : 0; // a and b are equal
          })
          .map((personaTile, key) => {
            if (personaTile && personaTile.acf) {
              return (
                <Grid.Column className="community-tile-column">
                  <div className="community-tile-menu">
                    <div>
                      <Link
                        to={
                          '/' +
                          this.props.match.params.community_slug +
                          '/' +
                          personaTile.acf.personacommunityNumber +
                          '-' +
                          personaTile.acf.title
                            .toLowerCase()
                            .replace(' - ', '-')
                            .replace(' ', '-')
                            .replace(' ', '-')
                            .replace(' ', '-')
                        }
                      >
                        <div className="community-tile-menu__link">
                          <span className="community-page-title-menu__number">
                            {personaTile.acf.personacommunityNumber}
                          </span>
                          <span className="community-page-title-menu__name">
                            {personaTile.acf.title}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                </Grid.Column>
              );
            } else {
              return '';
            }
          })
      : [];

    const communityImages = community
      ? community.knowMeImageGallery.map((communityImage, key) => {
          if (communityImage) {
            return (
              <Grid.Column>
                <Image
                  className="community-container__image"
                  src={communityImage.url}
                />
              </Grid.Column>
            );
          } else {
            return '';
          }
        })
      : [];
    return (
      <div>
        <PageTitle
          strapline={
            // $FlowFixMe
            community.postTitle ? community.postTitle : undefined
          }
          title={
            // $FlowFixMe
            'Helix Personas'
          }
        />
        <div className="page-row">
          <Container
            className="community-box"
            style={{ backgroundColor: community.acf.color }}
          >
            <Container className="community-box__container">
              <Grid columns={4}>
                <Grid.Row>{communityImages}</Grid.Row>
              </Grid>
              <div />

              <Grid columns={2} stackable>
                <Grid.Row>
                  <Grid.Column computer={6}>
                    <div className="community-container__text">
                      <h3>{community.postName}</h3>
                      <h4>
                        {community.postTitle
                          .replace(/[0-9]/g, '')
                          .replace('-', '')}
                      </h4>
                      {ReactHtmlParser(community.acf.summaryExcerpt)}
                      <Button
                        as={Link}
                        target={'_self'}
                        to={`//live.roymorgan.com/products/helix-personas`}
                        style={{
                          marginBottom: '10px',
                          display: 'table',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)'
                        }}
                      >
                        Read more about Helix Personas
                      </Button>
                      <Button
                        as={Link}
                        target={'_blank'}
                        to={`//helix.roymorgan.com/personas/${
                          community.postName
                        }`}
                        style={{
                          marginBottom: '10px',
                          display: 'table',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)'
                        }}
                      >
                        Log in to explore {community.postTitle}
                      </Button>
                    </div>
                  </Grid.Column>
                  <Grid.Column computer={6}>
                    <Grid columns={2} stackable>
                      <Grid.Row>{communityTiles}</Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Container>
        </div>

        <PageContent
          pageContent={
            // $FlowFixMe
            this.props.marketingPage.acf.pageContent
              ? this.props.marketingPage.acf.pageContent
              : undefined
          }
        />
        <OtherProducts currentProduct={currentProduct} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    personas: getPersonasSortedAlphabetically(state),
    marketingPage: state.marketingPages.pages['helix-personas-2018-homepage']
      ? state.marketingPages.pages['helix-personas-2018-homepage']
      : undefined,
    isFetchingMarketingPage: state.marketingPages.isFetching,
    isFetchingPersonas: state.personas.isFetching,
    products: state.products.items
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchPersonas,
      loadMarketingPage,
      fetchProducts
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Community);
